/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import { CSSProperties } from 'react';

/** 标准模态框宽度（与 Superset Modal 默认 600px 对齐） */
export const FORM_MODAL_WIDTH = {
  picker: '340px',
  sm: '440px',
  smWide: '480px',
  md: '600px',
  lg: '720px',
  panel: '780px',
  xl: '880px',
  xxl: '1000px',
  wide: '900px',
  full: '1240px',
} as const;

/** 可滚动内容区最大高度（页眉 + 页脚约 220px） */
export const FORM_MODAL_BODY_MAX_HEIGHT = 'calc(100vh - 220px)';

/** 多步向导类模态框（更高内容区） */
export const FORM_MODAL_BODY_MAX_HEIGHT_TALL = 'calc(100vh - 180px)';

export type FormModalScrollBodyOptions = {
  /** 使用更高的可视区域（ProjectModal 等） */
  tall?: boolean;
  /** 内部自行滚动时分区布局用 */
  overflowHidden?: boolean;
};

export function getFormModalScrollBodyStyle(
  options?: FormModalScrollBodyOptions,
): CSSProperties {
  return {
    maxHeight: options?.tall
      ? FORM_MODAL_BODY_MAX_HEIGHT_TALL
      : FORM_MODAL_BODY_MAX_HEIGHT,
    overflowY: options?.overflowHidden ? 'hidden' : 'auto',
  };
}
